export const resources = {
  junior: {
    macos: [
      { name: 'UX Writing Fundamentals', url: 'https://uxwritinghub.com/ux-writing-fundamentals/', type: 'fundamentals' },
      { name: 'Content Design Principles', url: 'https://contentdesign.london/content-design/what-is-content-design/', type: 'principles' },
      { name: 'Microcopy Best Practices', url: 'https://www.nngroup.com/articles/microcopy/', type: 'microcopy' },
      { name: 'Voice and Tone Guidelines', url: 'https://www.nngroup.com/articles/tone-of-voice-dimensions/', type: 'voice-tone' }
    ],
    windows: [
      { name: 'Microsoft Style Guide', url: 'https://docs.microsoft.com/en-us/style-guide/welcome/', type: 'style-guide' },
      { name: 'Content Creation with Office', url: 'https://support.microsoft.com/en-us/office', type: 'tools' },
      { name: 'SharePoint Content Management', url: 'https://docs.microsoft.com/en-us/sharepoint/', type: 'content-management' },
      { name: 'Teams Content Collaboration', url: 'https://docs.microsoft.com/en-us/microsoftteams/', type: 'collaboration' }
    ],
    linux: [
      { name: 'Open Source Writing Tools', url: 'https://github.com/topics/writing-tools', type: 'tools' },
      { name: 'Markdown for Content', url: 'https://www.markdownguide.org/', type: 'markup' },
      { name: 'Git for Writers', url: 'https://www.git-tower.com/learn/git/ebook/en/command-line/introduction', type: 'version-control' },
      { name: 'Content Workflow Automation', url: 'https://github.com/topics/content-automation', type: 'automation' }
    ]
  },
  mid: {
    macos: [
      { name: 'Advanced Content Strategy', url: 'https://gathercontent.com/blog/content-strategy-basics', type: 'strategy' },
      { name: 'Content Design Systems', url: 'https://designsystem.digital.gov/content-strategy/', type: 'design-systems' },
      { name: 'Conversational Design', url: 'https://developers.google.com/assistant/conversation-design', type: 'conversational' },
      { name: 'Content Performance Metrics', url: 'https://contentdesign.london/content-design/measuring-content-performance/', type: 'metrics' }
    ],
    windows: [
      { name: 'Advanced SharePoint Features', url: 'https://docs.microsoft.com/en-us/sharepoint/dev/', type: 'advanced-cms' },
      { name: 'Power Platform for Content', url: 'https://powerapps.microsoft.com/', type: 'automation' },
      { name: 'Azure Cognitive Services', url: 'https://docs.microsoft.com/en-us/azure/cognitive-services/', type: 'ai-content' },
      { name: 'Content Analytics with Power BI', url: 'https://powerbi.microsoft.com/', type: 'analytics' }
    ],
    linux: [
      { name: 'Advanced Git Workflows', url: 'https://www.atlassian.com/git/tutorials/comparing-workflows', type: 'version-control' },
      { name: 'Content APIs and Headless CMS', url: 'https://jamstack.org/headless-cms/', type: 'headless-cms' },
      { name: 'Content Automation Scripts', url: 'https://github.com/topics/content-automation', type: 'scripting' },
      { name: 'Static Site Generators', url: 'https://jamstack.org/generators/', type: 'static-sites' }
    ]
  },
  senior: {
    macos: [
      { name: 'Content Leadership', url: 'https://contentdesign.london/content-design/content-leadership/', type: 'leadership' },
      { name: 'Content Operations at Scale', url: 'https://gathercontent.com/blog/content-operations', type: 'operations' },
      { name: 'AI-Assisted Content Creation', url: 'https://www.nngroup.com/articles/ai-writing-tools/', type: 'ai-content' },
      { name: 'Content Strategy for Products', url: 'https://alistapart.com/article/content-strategy-for-mobile/', type: 'product-strategy' }
    ],
    windows: [
      { name: 'Enterprise Content Strategy', url: 'https://docs.microsoft.com/en-us/microsoft-365/contentunderstanding/', type: 'enterprise' },
      { name: 'AI Content Tools', url: 'https://docs.microsoft.com/en-us/azure/cognitive-services/text-analytics/', type: 'ai-tools' },
      { name: 'Content Governance', url: 'https://docs.microsoft.com/en-us/microsoft-365/compliance/', type: 'governance' },
      { name: 'Advanced Analytics', url: 'https://docs.microsoft.com/en-us/azure/synapse-analytics/', type: 'advanced-analytics' }
    ],
    linux: [
      { name: 'Content Infrastructure', url: 'https://github.com/topics/content-infrastructure', type: 'infrastructure' },
      { name: 'Machine Learning for Content', url: 'https://huggingface.co/models?pipeline_tag=text-generation', type: 'ml-content' },
      { name: 'Content Platform Architecture', url: 'https://github.com/topics/content-platform', type: 'architecture' },
      { name: 'Open Source Content Tools', url: 'https://github.com/topics/content-management', type: 'open-source' }
    ]
  }
};
